import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import { thunk } from "redux-thunk";
import { reducers } from "./Redux/reducer/index";
import { installApiCache } from "./helper/apiCache";

// Client-side response cache + automatic invalidation for every axios call.
// Installed before anything can fire a request. See helper/apiCache.js.
installApiCache(axios);

// Add a request interceptor to dynamically inject the authorization token if it is missing, null, or undefined.
axios.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem("user_token");
    if (token) {
      const auth = config.headers["Authorization"] || config.headers["authorization"];
      if (!auth || auth === "Bearer null" || auth === "Bearer undefined" || auth === "Bearer ") {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const store = createStore(reducers, compose(applyMiddleware(thunk)));

// window.sessionStorage.setItem("ms_auth", "eyJ0eXAiOiJKV1QiLCJub25jZSI6IlI3MjBSVlFxdE40Vk9WVTBsbFBsbzRtYzdIMDA5Q3g3VDNHdnBUbTlYRXMiLCJhbGciOiJSUzI1NiIsIng1dCI6ImFGa21LVkZjLTRXVjZzWENCdk5aa1hJNTA1WSIsImtpZCI6ImFGa21LVkZjLTRXVjZzWENCdk5aa1hJNTA1WSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8zZjRlNTYwMC1iYmJkLTQwNzItYjNiNi0yYTE0MTBmYTIwYzQvIiwiaWF0IjoxNzg0NTQxNjA2LCJuYmYiOjE3ODQ1NDE2MDYsImV4cCI6MTc4NDU0NTcyNCwiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicGZkciJdLCJhaW8iOiJBVVFBdS84Y0FBQUF6YU5saWMrcGhyL01xNFJHSU1kZ21QaW1pTFQyWlNub3EwUjhpLzRWSTRUSENPd0lhcWVFazVGN2g1MTdWdEJaQ3JnbjNMb1kwdDVPV2hmU0JNblo4Zz09IiwiYW1yIjpbInB3ZCJdLCJhcHBfZGlzcGxheW5hbWUiOiJjYWUiLCJhcHBpZCI6ImJlNjQxMWRmLTY4OGItNDY5Yi04YjY4LTI2ODI1YmQwNjQwOCIsImFwcGlkYWNyIjoiMSIsImZhbWlseV9uYW1lIjoiQWR2aXNvciIsImdpdmVuX25hbWUiOiJDYWUiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIyNDA1OjIwMTozMDA2OjU5OWI6NTkzNDo0MWRlOjU0ZmU6ZWJkMyIsIm5hbWUiOiJDYWUgQWR2aXNvciIsIm9pZCI6IjJiMTJkNWRmLTMyMDEtNDFjZS1iZmNmLWVlZTEyMTRhMWJiNyIsInBsYXRmIjoiNSIsInB1aWQiOiIxMDAzMjAwMjZCNjJBNTYzIiwicmgiOiIxLkFYSUFBRlpPUDcyN2NrQ3p0aW9VRVBvZ3hBTUFBQUFBQUFBQXdBQUFBQUFBQUFBQUFCNXlBQS4iLCJzY3AiOiJlbWFpbCBNYWlsLlJlYWQgTWFpbC5SZWFkLlNoYXJlZCBNYWlsLlJlYWRXcml0ZSBNYWlsLlJlYWRXcml0ZS5TaGFyZWQgTWFpbC5TZW5kIG9wZW5pZCBwcm9maWxlIFVzZXIuUmVhZCBVc2VyLlJlYWQuQWxsIiwic2lkIjoiMDA1Y2NkZWEtNmI0My01NjNhLTFkNmItNzQ1ZjM2MTNmNDVmIiwic2lnbmluX3N0YXRlIjpbImttc2kiXSwic3ViIjoiSFQ5eHh5aGJHWHdfM0F4Rk5JMW0zRVViVUFpaXFZamRHZEk5ektpZkRKNCIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJBUyIsInRpZCI6IjNmNGU1NjAwLWJiYmQtNDA3Mi1iM2I2LTJhMTQxMGZhMjBjNCIsInVuaXF1ZV9uYW1lIjoiYWR2aXNvckBjYWVuZC5jb20iLCJ1cG4iOiJhZHZpc29yQGNhZW5kLmNvbSIsInV0aSI6ImhxenhiTHlHbEVhWGRGVGhuNElxQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfYWNkIjoxNzMwMTk1NDQ4LCJ4bXNfYWN0X2ZjdCI6IjkgMyIsInhtc19mdGQiOiJKX1o3dW4xSVhlMnloOVN3OHlnczhrZENRVzk0MHpaSkpBZjBQOV9sR1pZQllYTnBZWE52ZFhSb1pXRnpkQzFrYzIxeiIsInhtc19pZHJlbCI6IjEgMjQiLCJ4bXNfcGZ0ZXhwIjoxNzg0NjMyMTI0LCJ4bXNfc3QiOnsic3ViIjoiZzRBQjUyeDV5T2h4bTJwM3B6aGhzT1pQMjAtVjBrMi1hbC1KTW1LLWxCWSJ9LCJ4bXNfc3ViX2ZjdCI6IjMgOCIsInhtc190Y2R0IjoxNDkyNjAyNjYyLCJ4bXNfdG50X2ZjdCI6IjIgMyJ9.ioT8nzxmhSuxQES4PClrm7zAsCuWcbFJtLh35lLmT-Jo1GnXrdVb7dutRgKxYkjmn3GlFl8pB3vaN-EVBj1579lkGJGx2GIJeAo-4ZeuHjQM_15LMzqqpEc9Asq9AsJqdbXeDDE8Rr4Ipb1-J-ZBKG7545Zo449AzmsnNSA9jDUroygxPxy_L27OHCNmltbkOy-XB1AkMfrxFHSIkiLaVA40JddJQaf3Mgz1MyiZg1tYk6iux4ISZgrhNC5DPcT7IV3k8F7dt0rUCb4lF5pMnIuCzLZl_U7ToUwN91dDa3VJtXXwEndII4t1gaFjUpZTXV_TP4CxWQpB3K0U4XkD1A");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

{/* <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
</React.StrictMode>; */}
